import React,{useEffect} from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';

const Bzsql = () => {

  useEffect(() => {
    hljs.addPlugin({
        'after:highlightElement': ({ result, el }) => {
            const lines = document.createElement('div');
            if (!result.value.includes('<span class="line-num">')) {
                lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
            }
            el.replaceChildren(...lines.childNodes);
        }
    });


    if (!document.querySelector('.hljs')) {
      hljs.highlightAll();
  }
   
  });


  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Bazy danych - SQL - XAMPP</h1>
            <hr></hr>
            <section>
              <h2>Wprowadzenie</h2>
              <blockquote class="introduction">
                <strong>Na egzaminie...</strong>
                Tutaj znajdziesz polecenia, które pojawiły się na egzaminie lub mogą się pojawić. Większość z nich czyli 85% była na egzaminie,
                więc warto sobie je powtórzyć :D
              </blockquote>
            </section>
            <hr />
            <section>
              <h3>SELECT</h3>
              <p>Polecenie SELECT służy do wybierania danych z bazy danych. Można je używać do pobierania wszystkich kolumn z tabeli lub tylko wybranych.</p>
              <pre><code>{`--Poniższe polecenie wybiera wszystkie kolumny z tabeli osoby.
SELECT * FROM osoby;
-- Poniższe polecenie wybiera tylko kolumny imie i miasto z tabeli osoby.
SELECT imie, miasto FROM osoby;`}</code></pre>
            </section>
            <section>
              <h3>DISTINCT</h3>
              <p>Polecenie DISTINCT służy do usuwania duplikatów z wyników zapytania. Używane jest w klauzuli SELECT w celu zwrócenia tylko unikalnych wierszy.</p>
              <pre><code>{`SELECT DISTINCT imie, miasto FROM osoby;`}</code></pre>
            </section>
            <section>
              <h3>WHERE</h3>
              <p>Słowo kluczowe WHERE pozwala na filtrowanie wyników zapytania na podstawie podanych warunków.</p>
              <pre><code>{`SELECT imie FROM osoby WHERE imie = 'Jakub';`}</code></pre>
              <p>Powyższe polecenie wybiera kolumnę imie z tabeli osoby tylko dla rekordów, gdzie wartość kolumny imie jest równa 'Jakub'.</p>
            </section>
            <section>
              <h3>AND, OR, NOT</h3>
              <p>Polecenia AND, OR i NOT są używane do łączenia lub odwracania warunków w klauzuli WHERE.</p>
              <pre><code>{`-- Zapytanie z AND (i)
SELECT * FROM osoby WHERE imie = 'Jakub' AND miasto = 'Sosnowiec';
-- Zapytanie z OR (lub)
SELECT * FROM osoby WHERE miasto = 'Sosnowiec' OR miasto = 'Bydgoszcz';
-- Zapytanie z NOT (nie)
SELECT * FROM osoby WHERE NOT imie = 'Jakub';`}</code></pre>
              <p>Powyższe polecenie wybiera kolumnę imie z tabeli osoby tylko dla rekordów, gdzie wartość kolumny imie jest równa 'Jakub'.</p>
            </section>  
            <section>
              <h3>ORDER BY</h3>
              <p>Słowo kluczowe ORDER BY służy do sortowania wyników zapytania w kolejności 
                rosnącej (ASC) lub malejącej (DESC) na podstawie jednej lub kilku kolumn.</p>
              <pre><code>{`SELECT nazwisko, telefon
FROM sklep
WHERE lokalizacja = 'Sosnowiec'
ORDER BY nazwisko DESC, telefon ASC;`}</code></pre>
              <p>Powyższe polecenie wybiera kolumny nazwisko i telefon z tabeli ksiazka_telefoniczna, gdzie wartość kolumny miasto jest równa 'Sosnowiec', sortując wyniki malejąco według nazwisko i rosnąco według telefon.</p>
            </section>
            <section>
              <h3>INSERT INTO</h3>
              <p>Polecenie INSERT INTO służy do wstawiania nowych rekordów do tabeli.</p>
              <pre><code>{`INSERT INTO persons (id, name, surname, city)
VALUES (10, 'Jakub', 'Jakubowski', 'Sosnowiec');`}</code></pre>
             
            </section>   
            <section>
              <h3>NOT</h3>
              <p>Słowo kluczowe NULL jest używane w warunkach, aby sprawdzić, czy pole jest puste (brak wartości) lub niepuste.</p>
              <pre><code>{`SELECT * FROM pracownicy WHERE firma IS NULL;
-- Lub
SELECT * FROM pracownicy WHERE firma IS NOT NULL;`}</code></pre>
            </section>      
            <section>
              <h3>UPDATE</h3>
              <p>Polecenie UPDATE służy do aktualizacji danych w tabeli. 
                Pozwala zmienić wartości jednej lub kilku kolumn w rekordach, które spełniają określone warunki.</p>
              <pre><code>{`UPDATE pracownicy
SET imie = 'Anna', nazwisko = 'Kowalska', miasto = 'Kraków'
WHERE id = 3;`}</code></pre>
            </section>    
            <section>
              <h3>DELETE</h3>
              <p>Polecenie DELETE służy do usuwania rekordów z tabeli, które spełniają określone warunki.</p>
              <pre><code>{`DELETE FROM pracownicy WHERE id = 5;`}</code></pre>
            </section>     
            <section>
              <h3>LIMIT</h3>
              <p>Słowo kluczowe LIMIT służy do ograniczenia liczby rekordów zwracanych przez zapytanie.</p>
              <pre><code>{`SELECT * FROM produkty LIMIT 5;`}</code></pre>
              <p>Powyższe polecenie wybiera pierwsze 5 rekordów z tabeli products.</p>
            </section>    
            <section>
              <h3>MIN i MAX</h3>
              <p>Funkcje MIN i MAX służą do wybierania minimalnej lub maksymalnej wartości z określonej kolumny.</p>
              <pre><code>{`SELECT MIN(cena) FROM ciuchy WHERE rozmiar = 19;`}</code></pre>
              <p>Powyższe polecenie wybiera minimalną wartość z kolumny cena w tabeli ciuchy, gdzie wartość kolumny rozmiar wynosi 19.</p>
            </section> 
            <section>
              <h3>LIMIT</h3>
              <p>Słowo kluczowe LIMIT służy do ograniczenia liczby rekordów zwracanych przez zapytanie.</p>
              <pre><code>{`SELECT * FROM produkty LIMIT 5;`}</code></pre>
              <p>Powyższe polecenie wybiera pierwsze 5 rekordów z tabeli products.</p>
            </section>
            <section>
              <h3>COUNT, AVG, SUM</h3>
              <p>Funkcja COUNT zwraca liczbę wierszy spełniających określony warunek.</p>
              <pre><code>{`SELECT COUNT(id) FROM klienci;`}</code></pre>
              <p>Funkcja AVG zwraca średnią wartość z wybranej kolumny.</p>
              <pre><code>{`SELECT AVG(ocena) FROM uczen;`}</code></pre>
              <p>Funkcja SUM zwraca sumę wartości z wybranej kolumny.</p>
              <pre><code>{`SELECT SUM(cena) FROM ciuchy;`}</code></pre>
            </section>     
            <section>
              <h3>LIKE</h3>
              <p>Słowo kluczowe LIKE używane jest w klauzuli WHERE do wyszukiwania rekordów, które pasują do określonego wzorca.</p>
              <pre><code>{`SELECT cena FROM ciuchy WHERE nazwa LIKE 'Addidas%';`}</code></pre>
              <p>Powyższe polecenie zwraca wszystkie rekordy z kolumny cena w tabeli ciuchy, 
                gdzie wartość kolumny name zaczyna się od 'Addidas'.</p>
                <table className='table table-striped table-hover' >
        <thead >
            <tr>
                <th style={{color:"#e3e3e3"}}>Operator LIKE</th>
                <th style={{color:"#e3e3e3"}}>Opis</th>
            </tr>
        </thead>
        <tbody >
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE 'a%'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które zaczynają się od litery "a".</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE '%a'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które kończą się na literę "a".</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE '%or%'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które zawierają "or" w dowolnym miejscu.</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE '_r%'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które mają literę "r" na drugiej pozycji.</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE 'a_%'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które zaczynają się od litery "a" i mają co najmniej 2 znaki.</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE 'a__%'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które zaczynają się od litery "a" i mają co najmniej 3 znaki.</td>
            </tr>
            <tr>
                <td style={{color:"#e3e3e3"}}>WHERE nazwa LIKE 'a%o'</td>
                <td style={{color:"#e3e3e3"}}>Znajduje wartości, które zaczynają się od litery "a" i kończą się na literę "o".</td>
            </tr>
        </tbody>
    </table>
            </section>    
            <section>
              <h3>IN</h3>
              <p>Słowo kluczowe IN służy do sprawdzania, czy wartość kolumny znajduje się w określonym zestawie wartości.</p>
              <pre><code>{`SELECT imie FROM pracownik WHERE miasto IN ('Sosnowiec', 'Bydgoszcz', 'Kraków');`}</code></pre>
              <p>Powyższe polecenie zwraca wszystkie rekordy z kolumny imie w tabeli pracownik, gdzie wartość kolumny miasto to 'Sosnowiec', 'Bydgoszcz' lub 'Kraków'.</p>
              <pre><code>{`SELECT imie
FROM pracownik 
WHERE miasto IN (
    SELECT miasto
    FROM biuro 
    WHERE region = 'Podkarpacie'
);`}</code></pre>
              <p>Powyższe polecenie zwraca wszystkie rekordy z kolumny surname w tabeli employees, gdzie wartość kolumny city znajduje się w wynikach zapytania podrzędnego.</p>
                 
            </section> 
            <section>
              <h3>BETWEEN</h3>
              <p>Słowo kluczowe BETWEEN zwraca rekordy, których wartość kolumny mieści się w określonym zakresie.</p>
              <pre><code>{`SELECT imie FROM klienci WHERE wiek BETWEEN 18 AND 30;`}</code></pre>
            </section> 
            <section>
              <h3>AS</h3>
              <p>Słowo kluczowe AS służy do nadawania aliasów kolumnom lub tabelom w wynikach zapytania. 
                Alias ułatwia czytanie wyników lub skraca nazwy kolumn.</p>
              <pre><code>{`SELECT numertelefonukomorkowego AS numertel FROM pracownik WHERE id = 5;`}</code></pre>
            </section>
            <section>
              <h3>JOIN</h3>
              <p>Polecenie JOIN służy do łączenia rekordów z dwóch lub więcej tabel na podstawie powiązań między nimi. Istnieje kilka rodzajów JOIN.</p>
              <h5>INNER JOIN</h5>
              <p>Polecenie INNER JOIN (złączenie wewnętrzne) łączy rekordy, które mają dopasowane wartości w obu tabelach.</p>
              <h5>LEFT JOIN</h5>
              <p>Polecenie LEFT JOIN (złączenie zewnętrzne lewostronne) zwraca wszystkie wiersze z tabeli po lewej stronie, a dopasowane wiersze z tabeli po prawej stronie. Jeśli nie ma dopasowania, zwraca wartości NULL dla kolumn prawej tabeli.</p>
              <h5>RIGHT JOIN</h5>
              <p>Podobnie jak LEFT JOIN ale z prawej strony</p>
              <h5>FULL JOIN</h5>
              <p>Polecenie FULL JOIN (złączenie zewnętrzne pełne) zwraca wszystkie wiersze, które mają dopasowane wartości w obu tabelach, oraz wszystkie wiersze niedopasowane z obu tabel, uzupełnione wartościami NULL.</p>
              <p>Przkład użycia INNER JOIN</p>
              <pre><code>{`SELECT pracownicy.imie, biuro.department_name
FROM pracownicy
INNER JOIN biuro
ON pracownicy.biuro_id = biuro.id;`}</code></pre>
            </section>   
            <section>
              <h3>UNION</h3>
              <p>Operator UNION łączy wyniki dwóch lub więcej zapytań w jeden zestaw wyników, eliminując duplikaty.</p>
              <pre><code>{`SELECT product_name, price FROM sales2019
UNION
SELECT product_name, price FROM sales2021;`}</code></pre>
            </section>
            <section>
              <h3>GROUP BY</h3>
              <p>Polecenie GROUP BY służy do grupowania wyników zapytania na podstawie wartości w jednej lub więcej kolumnach.</p>
              <pre><code>{`SELECT COUNT(id), miasto FROM pracownicy GROUP BY miasto;`}</code></pre>
              <p>Powyższe polecenie grupuje rekordy z tabeli customers według wartości w kolumnie city i zwraca liczbę rekordów dla każdego miasta.</p>
            </section> 
            <section>
              <h3>HAVING</h3>
              <p>Polecenie HAVING służy do filtrowania wyników grupowania. Działa podobnie do klauzuli WHERE, ale jest stosowane po GROUP BY.</p>
              <pre><code>{`SELECT COUNT(id), miasto FROM pracownicy GROUP BY miasto HAVING COUNT(id) > 5;`}</code></pre>
              <p>Powyższe polecenie grupuje rekordy z tabeli customers według miasta i zwraca tylko te grupy, które mają więcej niż 5 rekordów.</p>
            </section>
            <section>
              <h3>EXIST</h3>
              <p>Operator EXISTS sprawdza, czy podzapytanie zwraca jakiekolwiek wiersze. Jeśli tak, zwraca TRUE.</p>
              <pre><code>{`SELECT username FROM users WHERE EXISTS (SELECT * FROM transactions WHERE users.id = transactions.user_id);`}</code></pre>
              <p>Powyższe polecenie zwraca nazwy użytkowników z tabeli users, dla których istnieją powiązane transakcje w tabeli transactions.</p>
            </section>
            <section>
              <h3>ANY, ALL</h3>
              <p>Operator ANY zwraca TRUE, jeśli dowolny wiersz w podzapytaniu spełnia warunek.Natomaist operator ALL jeśli wszystkie.</p>
              <pre><code>{`SELECT produkt FROM produkty WHERE cena < ANY (SELECT cena FROM przecena);`}</code></pre>
            </section>
            <section>
              <h3>CASE</h3>
              <p>Polecenie CASE działa jak instrukcja warunkowa, która zwraca różne wartości w zależności od spełnienia określonych warunków.</p>
              <pre><code>{`SELECT imie, nazwisko, age,
CASE
    WHEN wiek < 30 THEN 'Młodszy pracownik'
    WHEN wiek > 30 THEN 'Starszy pracownik'
    ELSE 'Pracownik w wieku 30 lat'
END AS status
FROM pracownicy;`}</code></pre>
            </section>
            <section>
              <h3>CREATE, DROP</h3>
              <p>Polecenie CREATE służy do tworzenia nowych baz danych, tabel, indeksów, widoków i innych obiektów w bazie danych, a DROP do usunięcia</p>
              <pre><code>{`-- Stworzenie i usunięcie nowej bazy
CREATE DATABASE nazwa_bazy_danych;
DROP DATABASE przykladowabaza;

-- Stworzenie i usunięcie nowej tabeli
CREATE TABLE nazwa_tabeli (
id INT,
imie VARCHAR(30),
nazwisko VARCHAR(30)
);
DROP TABLE nazwa_tabeli;

-- Stworzenie i usunięcie użytkownika
CREATE USER 'new_user'@'localhost' IDENTIFIED BY 'haslo123@#';
DROP USER 'new_user'@'localhost';
`}</code></pre>
            </section>
            <section>
              <h3>CREATE VIEW</h3>
              <p>Polecenie CREATE VIEW służy do tworzenia widoków w bazie danych.
                 Widok jest wirtualną tabelą, która opiera się na wynikach zapytania SELECT. 
                Widoki mogą uprościć złożone zapytania i zapewnić dodatkowy poziom abstrakcji.</p>
              <pre><code>{`CREATE VIEW active_users AS
SELECT id, username, email
FROM users
WHERE active = 1;`}</code></pre>
<p>Powyższe polecenie tworzy widok active_users, który zawiera id, username i email użytkowników z tabeli users, gdzie kolumna active jest równa 1.</p>
            </section>
            <section>
              <h3>TRUNCATE</h3>
              <p>Polecenie TRUNCATE usuwa wszystkie dane z tabeli, ale zachowuje jej strukturę.</p>
              <pre><code>{`TRUNCATE TABLE klienci;`}</code></pre>
            </section>   
            <section>
              <h3>ALTER TABLE</h3>
              <p>Polecenie ALTER TABLE służy do modyfikacji struktury tabeli. Można dodawać, usuwać lub zmieniać kolumny.</p>
              <pre><code>{`-- Dodaje nową kolumnę
ALTER TABLE produkty
ADD opis VARCHAR(255);

-- Usuwa kolumne
ALTER TABLE produkty
DROP opis;

-- Modyfikuje kolumne
ALTER TABLE produkty
MODIFY nazwa VARCHAR(100);`}</code></pre>
            </section> 
            <section>
              <h3>GRANT</h3>
              <p>Polecenie GRANT służy do nadawania uprawnień użytkownikom na poziomie bazy danych, tabeli lub kolumny.</p>
              <pre><code>{`GRANT ALL PRIVILEGES ON *.* TO 'nowy'@'localhost';`}</code></pre>
              <ol className='listmargin'>
                <li>ALL PRIVILEGES: Wszystkie uprawnienia</li>
                <li>CREATE: Zezwala na tworzenie nowych baz danych i tabel</li>
                <li>DROP: Zezwala na usuwanie baz danych i tabel</li>
                <li>DELETE: Zezwala na usuwanie rekordów</li>
                <li>INSERT: Zezwala na wprowadzanie rekordów</li>
                <li>UPDATE: Zezwala na modyfikację rekordów</li>
                <li>GRANT OPTION: Zezwala na dodawanie i usuwanie uprawnień innym użytkownikom</li>
              </ol>
            </section>     
            <section>
              <h3>REVOKE</h3>
              <p>Polecenie REVOKE służy do odbierania uprawnień nadanych wcześniej użytkownikom.</p>
              <pre><code>{`REVOKE SELECT ON *.* FROM 'nowy'@'localhost';`}</code></pre>
              
            </section>  
            <section>
              <h3>ROLE</h3>
              <p>Role w MySQL umożliwiają grupowanie uprawnień, które można następnie przypisywać użytkownikom.</p>
              <pre><code>{`CREATE ROLE admin_role;

GRANT ALL PRIVILEGES ON *.* TO admin_role;

GRANT admin_role TO 'nowy'@'localhost';

REVOKE admin_role FROM 'nowy'@'localhost';

DROP ROLE admin_role;`}</code></pre>
<p>Powyższe polecenia tworzą rolę admin_role, nadają jej wszystkie uprawnienia, przypisują tę rolę użytkownikowi nowy na hostie localhost, odbierają ją od tego użytkownika, a na koniec usuwają rolę admin_role.</p>
              
            </section>                   
          </div>
        </div>
    </div>
  )
}

export default Bzsql